import * as Yup from 'yup';
import { OptionalObjectSchema } from 'yup/lib/object';
import { Namespace, TFunction } from 'react-i18next';
import { addDays, addMonths, endOfDay, format, startOfDay } from 'date-fns';

export const screenAndProtectDetailsSchema = (
  t: TFunction<Namespace<'en'>>,
) => {
  const minStartDate = addDays(startOfDay(new Date()), 2);
  const maxStartDate = addMonths(endOfDay(new Date()), 6);

  return {
    agreeToTerms: Yup.boolean().oneOf([true]).required(),
    agreeToPrivacy: Yup.boolean().oneOf([true]).required(),
    selectedProperties: Yup.array().of(Yup.string()).required(),
    reservationType: Yup.string().required(),
    startDate: Yup.date()
      .min(
        minStartDate,
        t(
          'pageScreenAndProtect.detailsPage.sections.protectionDetails.startDateMinValue',
          { date: format(minStartDate, 'yyyy-MM-dd') },
        ),
      )
      .max(
        maxStartDate,
        t(
          'pageScreenAndProtect.detailsPage.sections.protectionDetails.startDateMaxValue',
          { date: format(maxStartDate, 'yyyy-MM-dd') },
        ),
      )
      .required(t('form.validation.invalidDate')),
  };
};

export type ScreenAndProtectDetailsFormSchemaType = Yup.InferType<
  OptionalObjectSchema<ReturnType<typeof screenAndProtectDetailsSchema>>
>;
